import * as LDClient from "launchdarkly-js-client-sdk";
import { getLdContext } from "./ldHelper";

// Initialize LaunchDarkly client to check flags before app setup
const ldClient = LDClient.initialize(
  import.meta.env.VITE_APP_LD_CLIENT_ID,
  getLdContext()
);

export default ldClient;
